import React from 'react';
import sassVars from '../style/_common.scss';

export default () => {
  let svgProps = {
    cx: '6',
    cy: '6',
    r: '5',
    stroke: '#00000088',
    strokeWidth: '1',
  };

  return (
    <div className="leftrow wrap">
      <p>
        <svg height="12" width="12">
          <circle {...svgProps} fill={sassVars.greenColor} />
        </svg>{' '}
        Pure DPC
      </p>
      <div style={{ width: '12px' }} />
      <p>
        <svg height="12" width="12">
          <circle {...svgProps} fill={sassVars.redColor} />
        </svg>{' '}
        Hybrid
      </p>
      <div style={{ width: '12px' }} />
      <p>
        <svg height="12" width="12">
          <circle {...svgProps} fill={sassVars.blueColor} />
        </svg>{' '}
        Onsite
      </p>
      <div style={{ width: '12px' }} />
      <p>
        <svg height="12" width="12">
          <circle {...svgProps} fill={sassVars.yellowColor} />
        </svg>{' '}
        Unknown/other
      </p>
    </div>
  );
};
